import React from 'react'
import './spinner.css'

const Spinner = () => {
    return <div className='spinner-container'>           
        <img className="spinner" src='spinner.png' alt='car wheel loader' />
    </div>
}

export default Spinner